import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import ActionCable from 'components/ActionCable/Cable';
import IconMainContainer from 'components/IconMainContainer';
import { postRequest } from 'utils/api';
import toast from 'utils/toast';
import useWishlistCheckoutSuccess from 'hooks/useWishlistCheckoutSuccess';
import useLoginUser from 'hooks/useLoginUser';
import useModalData from 'hooks/useModalData';

const ApplePayForm = () => {
  const isLoggedIn = useSelector(state => state.auth.loggedIn);
  const { wish } = useModalData('Wish Checkout');
  const { userInfo, wishInfo, priceInfo } = useModalData('Payment');
  const handleCheckoutSuccess = useWishlistCheckoutSuccess();
  const loginUser = useLoginUser();

  const handleSubmit = useCallback(
    response => {
      if (response.token) {
        const { cardDetails, billingInfo } = response.wallet;

        postRequest({
          endpoint: `wishlist_items/${wish.id}/checkout?async=true`,
          data: {
            payment_method: 'apple_pay',
            token: response.token,
            card: {
              last4: cardDetails,
              billing_details: {
                name: `${billingInfo?.firstName} ${billingInfo?.lastName}`,
                zip: billingInfo?.postalCode,
                country: billingInfo?.country,
              },
            },
            user: userInfo,
            wish: wishInfo,
          },
          successMessage: '',
          showErrors: true,
        })
          .then(response => {
            if (isLoggedIn) {
              // Do nothing, we're waiting for the WebSocket update
            } else {
              loginUser(response);
            }
          })
          .catch(error => console.log('error', error));
      } else {
        toast('error', 'There was an error validating your payment method.', {
          icon: <IconMainContainer src="/icons/notifications/times.svg" alt="Times" errorStyle />,
        });
      }
    },
    [wish.id, isLoggedIn, loginUser, userInfo, wishInfo]
  );

  useEffect(() => {
    if (!window.CollectJS) return;

    window.CollectJS.configure({
      callback: response => {
        handleSubmit(response);
      },
      country: 'US',
      currency: 'USD',
      price: priceInfo.checkout_price,
      fields: {
        applePay: {
          selector: '#apple-pay-button',
          requiredBillingContactFields: ['name'],
          requiredBillingContactFields: ['postalAddress'],
          requiredShippingContactFields: [],
          contactFields: [],
          // contactFields: ['phone', 'email'],
          // contactFieldsMappedTo: 'billing',
          lineItems: [
            {
              label: wish.name,
              amount: priceInfo.price,
            },
          ],
          totalLabel: 'Total Price',
          type: 'buy',
          style: {
            'button-style': 'black',
            height: '50px',
            'border-radius': '5px',
          },
        },
      },
    });
  }, [priceInfo.checkout_price, priceInfo.price, wish.name, handleSubmit]);

  return (
    <>
      <ActionCable
        channel="CheckoutChannel"
        onReceived={({ type, payload }) => {
          if (type === 'success') {
            handleCheckoutSuccess();
          } else {
            toast(
              'error',
              payload?.errors?.[0] ||
                'There was an error during the checkout. Please try again or contact support.',
              {
                icon: (
                  <IconMainContainer src="/icons/notifications/times.svg" alt="Times" errorStyle />
                ),
              }
            );
          }
        }}
      />

      <div id="apple-pay-button" style={{ margin: '20px 0', padding: '0 15px' }}></div>
    </>
  );
};

export default ApplePayForm;
